import css from "styled-jsx/css";
import {
  BACKGROUND_GRAY_COLOR_NAME,
  WHITE_COLOR_NAME,
  SPACE_BLUE_GRADIANT_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME
} from "styles/color-consts";
import Colors from "styles/colors";
import { HIDDEN } from "constants/z-index";

const BORDER_RADIUS = "8px";
const BOX_WIDTH = "624px";
const COMPONENT_TOP_MARGIN = 80;

const BACKGROUND_HEIGHT = COMPONENT_TOP_MARGIN + 480;
const BORDER = `2px solid ${Colors[BACKGROUND_GRAY_COLOR_NAME]}`;

export const componentStyles = css.global`
  .welcome-back-homepage-first-fold-component {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .background-color-div {
      position: absolute;
      height: ${BACKGROUND_HEIGHT} + px;
      width: 100%;
      z-index: ${HIDDEN};
      background: ${Colors[SPACE_BLUE_GRADIANT_COLOR_NAME]};
    }

    .welcome-back-first-fold-message {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: ${BOX_WIDTH};
      margin-top: ${COMPONENT_TOP_MARGIN} + px;

      .monday-logo {
        .picture-component {
          display: flex;
          .monday-logo-picture {
            width: 62px;
          }
        }
      }

      .welcome-text-and-image {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .welcome-text-wrapper {
          font-size: 40px;
          color: ${Colors[WHITE_COLOR_NAME]};
          .welcome-text {
            font-weight: 300;
          }
          .user-name {
            font-weight: 700;
            padding-bottom: 8px;
            transition: opacity 0.1s;
            opacity: 1;
          }
        }
        .welcome-image {
          align-self: flex-end;

          .picture-component {
            display: flex;
            .hands-picture {
              width: 192px;
            }
          }
        }
      }
    }

    .accounts-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;

      .accounts-details-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: ${BOX_WIDTH};
        border: ${BORDER};
        border-radius: ${BORDER_RADIUS};

        .last-account-details-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;

          .last-account-title {
            width: 100%;
            display: flex;
            justify-content: center;
            background: ${Colors["brand-yellow"]};
            border-top-right-radius: ${BORDER_RADIUS};
            border-top-left-radius: ${BORDER_RADIUS};

            font-weight: 400;
            font-size: 18px;
            color: ${Colors.mud};
            padding-top: 20px;
            padding-bottom: 20px;
          }
          .last-account-details {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-bottom-right-radius: ${BORDER_RADIUS};
            border-bottom-left-radius: ${BORDER_RADIUS};

            background: ${Colors[WHITE_COLOR_NAME]};

            .user-image-wrapper {
              margin-top: 26px;
              .user-image {
                width: 50px;
              }
            }
            .last-account-user-company {
              margin-top: 12px;
              font-weight: 700;
              font-size: 20px;
              color: ${Colors.mud};
              transition: opacity 0.1s;
              opacity: 1;
            }
            .last-account-user-email {
              margin-top: 6px;
              font-weight: 300;
              font-size: 20px;
              color: ${Colors.mud};
              transition: opacity 0.1s;
              opacity: 1;
            }

            .last-account-button-wrapper {
              margin-top: 24px;
              margin-bottom: 42px;
            }
          }
        }
      }
    }
    .rest-accounts-wrapper {
      .older-account-boxes-wrapper {
        border-top: ${BORDER};
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 0;

        .older-account-title {
          margin-bottom: 12px;
          font-weight: 300;
          font-size: 16px;
          color: ${Colors.asphalt};
        }

        .account-box {
          width: ${BOX_WIDTH};
          margin-top: 12px;

          .account-box-data {
            margin: 16px 24px;
            display: flex;
            align-items: center;

            .old-account-image-wrapper {
              margin-left: 6px;
              .old-account-user-image {
                width: 32px;
              }
            }
            .old-account-user-details {
              margin-left: 12px;
              display: flex;
              flex-direction: column;
              color: ${Colors.mud};

              .old-account-user-company {
                font-weight: 700;
                font-size: 16px;
                padding-bottom: 6px;
              }
              .old-account-user-email {
                font-weight: 300;
                font-size: 14px;
              }
            }

            .old-account-button-wrapper {
              margin-left: auto;
            }
          }
        }
      }
    }
    .general-login-wrapper {
      margin-top: 24px;
      font-weight: 300;
      font-size: 16px;
      color: ${Colors.asphalt};

      .no-account-link {
        padding-left: 6px;
        color: ${Colors[WORK_OS_IRIS_COLOR_NAME]};
      }
    }

    &.slugs-not-loaded {
      .welcome-back-first-fold-message {
        .welcome-text-and-image {
          .user-name {
            opacity: 0;
          }
        }
      }
      .accounts-wrapper {
        .accounts-details-box {
          .last-account-details-wrapper {
            .last-account-details {
              .last-account-user-company,
              .last-account-user-email {
                opacity: 0;
              }
            }
          }
        }
      }
    }
  }
`;
